import { render, staticRenderFns } from "./IPUsers.vue?vue&type=template&id=875e1c20"
import script from "./IPUsers.vue?vue&type=script&lang=js"
export * from "./IPUsers.vue?vue&type=script&lang=js"
import style0 from "./IPUsers.vue?vue&type=style&index=0&id=875e1c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports